module.exports = __webpack_public_path__ + "static/media/drb.7b6435cd.gif";